import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Cart, CartItemBase, RootState, settings, user, Utilities } from 'core';
import { actions as cartActions } from 'core/use-cases/cart/actions';
import { selectors as cartSelectors } from 'core/use-cases/cart';
import { selectors as userSelectors } from 'core/use-cases/user';
import { HeaderSearchResultHookProps } from '../HeaderSearchResult.d';
import { useCatalog } from '../../../hooks/useCatalog';
import { editCatalogInfos } from '../../../helpers/edit-catalog-infos';

export const useHeaderSearchResultWidget = ({ handleClearSearch }: HeaderSearchResultHookProps) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { status, query } = useCatalog();
  const previewSearch = useSelector((state: RootState) => state.catalog.previewSearch);
  const isRunningPreview = useSelector((state: RootState) => state.catalog.isRunningPreview);
  const {
    data: { isResaleIntention, isAutoStartEnabled },
  } = useSelector((state: RootState) => state.user);
  const { data: cartData } = cartSelectors.useCartSelector();
  const itemAddCartError = userSelectors.useItemAddCartErrorSelector();

  const catalogData = editCatalogInfos({ data: previewSearch, cartData, itemAddCartError });

  const { isBuyIntention } = user.hooks.useIsBuyIntention();

  const isLoading = isRunningPreview;
  const notFound = status === Utilities.STATUS.SUCCESS && previewSearch.length === 0;

  const isBuyIntentionFeatureActive = settings.hooks.useFeatureToggle('buyIntention');

  const clickProductDetail = (slugname: string, productCode: string) => {
    handleClearSearch();
    history.push(`/produto/${slugname}?sku=${productCode}`);
  };

  const addItem = (productCode: CartItemBase['productCode'], itemListName?: string) => {
    dispatch(cartActions.itemAddFetch.request({ productCode, quantity: 1, itemListName }));
  };

  const updateItem = (queryOptions: CartItemBase) => {
    dispatch(cartActions.itemUpdateFetch.request(queryOptions));
  };

  const setBuyIntention = (
    productCode: Cart['data']['items'][number]['productCode'],
    name: string,
  ) => {
    dispatch(user.actions.userBuyIntentionFetch.request({ productCode, quantity: 1, name }));
  };

  return {
    data: catalogData,
    query,
    isLoading,
    notFound,
    addItem,
    updateItem,
    isBuyIntentionFeatureActive,
    setBuyIntention,
    isBuyIntention,
    isResaleIntention,
    isAutoStartEnabled,
    clickProductDetail,
  };
};
